export const parseTime = (timeStr, referenceDate = new Date()) => {
    const [hour, minute] = timeStr.split(":").map(Number);
    const d = new Date(referenceDate);
    d.setHours(hour, minute, 0, 0);
    return d;
  };
  
  export const getItalianDay = (date) => {
    const days = ["domenica","lunedì","martedì","mercoledì","giovedì","venerdì","sabato"];
    return days[date.getDay()];
  };
  
